import Vue from 'vue';
import Vuex from 'vuex';
import state from './state.js';
import getters from './getters.js';
import mutations from './mutations.js';
import actions from './actions.js';

Vue.use(Vuex);
export default new Vuex.Store({
  // state: {
  //   createFileDone: false,
  //   editFileDone: false
  // },
  mutations: {
    changeCDate(state) {
      state.createFileDone = !state.createFileDone
    },
    changeEDate(state) {
      state.editFileDone = !state.editFileDone
    }
  },
  state,
  getters,
  mutations,
  actions,
  strict: process.env.NODE_ENV !== 'production'
},
);
